<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import GroupBase from '../../../../../groups/components/GroupBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        featureFlags: 'groups',
    }
})
</script>

<template>
  <GroupBase />
</template>